// sessionReducer.js

const initialState = null; // Initial state

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SESSION':
        console.log("aaaaaaaaaaaaaaaaaaaa",action);
      return action.payload; // Set the session value
    
    default:
      return state;
  }
};

export default sessionReducer;

